import { useEffect } from "react";
import { useAuthSessionStore } from "../features/auth";
import { useCloudAnnotationsStore } from "../features/annotations";
import { useAnnotationStore } from "../features/annotations/store/local-annotations";
import { useTeamStore } from "../features/prompts";
import { type ConnectionState } from "../lib/shell-messenger";

export function useAnnotationsLoader(connectionState: ConnectionState): void {
  const isAuthenticated = useAuthSessionStore((state) => state.isAuthenticated);
  const isPro = useAuthSessionStore((state) => state.subscription?.isPro ?? false);
  const activeWorkspace = useTeamStore((state) => state.activeWorkspace);
  const loadLocalAnnotations = useAnnotationStore(
    (state) => state.loadAnnotations,
  );
  const fetchCloudAnnotations = useCloudAnnotationsStore(
    (state) => state.fetchAnnotations,
  );

  const isCloudAnnotationsSource = isAuthenticated && isPro;
  const annotationsContextKey = isCloudAnnotationsSource
    ? activeWorkspace.type === "team"
      ? `team:${activeWorkspace.teamId}`
      : "personal"
    : "local";

  useEffect(() => {
    if (connectionState !== "connected") {
      return;
    }

    if (isCloudAnnotationsSource) {
      void fetchCloudAnnotations();
      return;
    }

    void loadLocalAnnotations();
  }, [
    annotationsContextKey,
    connectionState,
    fetchCloudAnnotations,
    isCloudAnnotationsSource,
    loadLocalAnnotations,
  ]);
}
